// extracted by mini-css-extract-plugin
module.exports = {"block":"_18136","hd":"_2883","title":"_467","text":"_3829","desc":"_18738","more":"_7116","arrow":"_47","full":"_655","padding":"_10860","noTop":"_14664"};